import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduationSearchContent from 'src/components/PostGraduationContent/PostGraduationSearch/PostGraduationSearchContent'

const PostGraduationSearchPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      <Navbar />
      <PostGraduationSearchContent />
      <Footer />
    </>
  )
}

export default PostGraduationSearchPage
